export default "__VITE_ASSET__0ad5dc02__"